import React, {useState, useEffect, useRef} from "react";
import {useTranslation, withTranslation} from "react-i18next";
import {useHistory, useRouteMatch} from "react-router-dom";
import images from "../../../ressources/images";
import {getOneClickById} from "../../../api/brands";

const OneClick = (props) => {
    const { i18n } = useTranslation();
    const match = useRouteMatch();
    const history = useHistory();
    const [oneClick, setOneClick] = useState();
    const pageRef = useRef();

    const goBack = () => {
        history.goBack();
    };

    const fetchData = async () => {
        const oneClickContent = await getOneClickById(match.params.id);
        setOneClick(oneClickContent)
    };

    const handleResize = () => {
        const layoutContainer = document.querySelector(
            ".default-layout--container"
        );

        const containerHeight = layoutContainer.clientHeight;

        if (pageRef.current) {
            pageRef.current.style.height = containerHeight + "px";
        }
    };

    useEffect(() => {
        fetchData();
    }, [match, i18n]);

    useEffect(() => {
        // If this was done properly in the first place, this would not be needed,
        // but it would require too many changes and verification to use height: 100%
        // Once the new css viewport units are compatible with most browsers this could be replaced
        // with something like this: "height: calc(100svh - XXpx);"
        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div className="onehr-show" ref={pageRef}>
            <div className="onehr-header">
                <button className="onehr-header__close-btn" onClick={goBack}>
                    <img src={images.closeCross} alt="" />
                </button>
            </div>
            {oneClick && (
                <iframe className="onehr-iframe" src={oneClick.url}></iframe>
            )}
        </div>
    );
};

export default withTranslation('global')(OneClick)
